// extracted by mini-css-extract-plugin
export default {"vertical_content_container":"VerticalAlertContent_vertical_content_container__s76dg"};